import { TherapeuticArea } from "../typings/interfaces"

export const getTherapeuticAreaName = (therapeuticArea: string, therapeuticAreas: TherapeuticArea[]) => {
  const foundArea = therapeuticAreas.find((obj) => obj.value ===  therapeuticArea);
  if (foundArea) {
    return foundArea
  }
  return null;
}